import React,{ useState, useEffect ,forwardRef} from 'react'
import { useDispatch } from "react-redux";
import { getUser, updateUserById } from "./../../../../services/global_redux/globale_actions/Login.action"
import { getAllUnits } from "./../../../../services/global_redux/globale_actions/Unit.action"
import { getRole} from "./../../../../services/global_redux/globale_actions/Role.action"
import mainLogo from "./../../../../assets/global_assets/assignClients/mainIcon.png"
import slno_icon from "./../../../../assets/global_assets/assignClients/Slno_icon.png"
import branch_icon from "./../../../../assets/global_assets/assignClients/branch_icon.png"
import org_name_icon from "./../../../../assets/global_assets/assignClients/org_name_icon.png"
import selected_icon from "./../../../../assets/global_assets/assignClients/selected_icon.png"
import permitted_branch from "./../../../../assets/global_assets/assignClients/permitted_branch.png"
import into_icon from "./../../../../assets/global_assets/create_data_imgs/into_icon.png"
import mainInto from "./../../../../assets/global_assets/assignClients/mainInto.png"
import arrow_down from "./../../../../assets/reUsableTemplates_assets/arrow_down.png"
import arrow_up from "./../../../../assets/reUsableTemplates_assets/arrow_up.png"
import Select from 'react-select';
import TextField from '@mui/material/TextField';
import "./AssignClient.css"
import { Modal } from 'react-bootstrap';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
function AssignClient({ showSnackbar, setLoading }) {
    const dispatch = useDispatch();
    const [clientAndUnit, setClientAndUnit] = useState([]);
    const [selectedClients, setSelectedClients] = useState({});
    const [selectedUnits, setSelectedUnits] = useState({});
    const [userData, setUserData] = React.useState([])
    const use_company_code = JSON.parse(sessionStorage.getItem('user') || "{}") || {};
    const currentUserBaseRole = use_company_code.base_role;
    const currentUserclient_and_unit = use_company_code.client_and_unit;
    const [checkRoles , setCheckRoles] = useState([]);
    const [selectedClientID, setSelectedClientID] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [showPermitted, setShowPermitted] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState("");
    const [activeTab, setActiveTab] = useState(null);
    const [isAllUnitsChecked, setIsAllUnitsChecked] = useState(false);
    const [asignedData, setAsignedData] = useState([]);
    const [openalert, setopenalert] = useState(false);
    useEffect(() => {
      const savedTab = sessionStorage.getItem('activeTab') || "Registers";
      setActiveTab(savedTab);
    }, []);


    const selectedClienthandleSubmit = async () => {
      if(!selectedUserId){
        setShowPermitted(false);
        return showSnackbar("Select the User", "error")
      }
        const data = getSelectedData();
        if(selectedUserId && (!data || data.length === 0)){
          console.log(asignedData);
          if(!asignedData || asignedData.length === 0){
              showSnackbar("No Clients Assigned to this user", "warning");
          }else{
              // showSnackbar("All Clients Unassigned from this user", "warning");
              closeModel();
              setopenalert(true);
          }
          
        // setShowPermitted(false);
        // return showSnackbar("Assign Organization and Branches", "error")
      }else{
        confirmUnassign();
      }

    };
    const confirmUnassign = async () => {

      setopenalert(false);
      
        const data = getSelectedData();
        const send_data = {
            'client_and_unit':data
        }

        try {
            const response = await dispatch(updateUserById(selectedUserId,send_data));
            if (response.success == true) {
                showSnackbar(response.message, "success");
                setLoading(false);
                FetchUser()
                handleFetchClientAndUnit();
                setShowPermitted(false);
                handleSelectChange();
            }else if(response.success == false){
                showSnackbar(response.message, "error");
                setLoading(false);
                FetchUser()
                setShowPermitted(false);
            } else {
                showSnackbar(response.message, "warning");
                setLoading(false);
                setShowPermitted(false);
            }
        } catch (err) {
            console.error("Failed to fetch states:", err);
        }
    }
    const handleClosealert = () =>{
      setopenalert(false);
      const dataevent = {
        target: {
          name: 'emp_role',
          value: selectedUserId,
        },
      }
      handleRoleChangeuserID(dataevent);
    }
    const getSelectedData = () => {
        
        const result = selectedEntries.map(item => ({
          client_id: item.clientId,
          unit_id: item.branches.map(branch => branch.id)
        }));


        return result;
    };

    const FetchUser = async () => {
      try {
        const response = await dispatch(getUser());
        console.log(response);
        setUserData(Array.isArray(response.data) ? response.data : []);
        
      } catch (err) {
        console.error("Failed to fetch states:", err);
      }
    };

  useEffect(() => {
    FetchUser();
  }, [dispatch]);
  const handleFetchRole = async () => {
    try {
      const response = await dispatch(getRole());
        if(currentUserBaseRole === "SuperAdmin"){
            setCheckRoles(response.data.filter((data)=> data.base_role !== "SuperAdmin").map((data)=> data.role_name));
        }else if(currentUserBaseRole === "Admin"){

            setCheckRoles(response.data.filter((data)=> data.base_role !== "SuperAdmin" &&  data.base_role !== "Admin" ).map((data)=> data.role_name));
        }else if(currentUserBaseRole === "Processor"){
            setCheckRoles(response.data.filter((data)=> data.base_role === "Client").map((data)=> data.role_name));
        }else{
            setCheckRoles(null);
        }
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  useEffect(() => {
    handleFetchRole();
  }, [dispatch]);

  const handleFetchClientAndUnit = async () => {
    try {
        if(currentUserBaseRole === "SuperAdmin"){

            const response = await dispatch(getAllUnits());
            if(response.data){
              setClientAndUnit(Array.isArray(response.data.client_and_unit) ? response.data.client_and_unit : []);
            } else {
              setClientAndUnit([]);
            }
        }else{

            const response = await dispatch(getAllUnits());

            let parsedClientArray = JSON.parse(currentUserclient_and_unit || "[]");
            const parsedArray = typeof parsedClientArray === "string"
              ? JSON.parse(parsedClientArray)
              : parsedClientArray;

            if (!Array.isArray(parsedArray)) {
              throw new Error("parsedArray is not an array");
            }

            const allowedClientMap = new Map();
            parsedArray.forEach(({ client_id, unit_id }) => {
              allowedClientMap.set(client_id, new Set(unit_id || []));
            });

            const sourceList = Array.isArray(response.data?.client_and_unit)
              ? response.data.client_and_unit
              : [];
            const filteredClients = sourceList
              .map(client => {
                const allowedUnits = allowedClientMap.get(client.client_id);
                if (!allowedUnits) return null;

                const matchingUnits = (client.unit_id || []).filter(unit => allowedUnits.has(unit));
                if (matchingUnits.length === 0) return null;

                return {
                  ...client,
                  unit_id: matchingUnits,
                  unit_names: client.unit_names?.filter((_, i) => allowedUnits.has(client.unit_id[i])) || [] // optional
                };
              })
              .filter(Boolean);

            setClientAndUnit(filteredClients);
        }
    } catch (err) {
      console.error(" Failed to fetch client and unit data:", err);
      setClientAndUnit([]);
    }
  };
  useEffect(() => {
    handleFetchClientAndUnit();
  }, [dispatch]);

  const handleSelectChange = (e) => {
    console.log(e);
    let fakeEvent = "";
    if(e === undefined){
       fakeEvent = {
        target: {
          name: 'emp_role',
          value:  "",
        },
      };
      setSelectedUserId("");
    }else{
      const { name, value } = e.target;
       fakeEvent = {
        target: {
          name: 'emp_role',
          value: value ? value : "",
        },
      };
      setSelectedUserId(value);
    }
    console.log(fakeEvent);
    handleRoleChangeuserID(fakeEvent);
  };
  const handleRoleChangeuserID = (e) => {
    const userSelectedID = e.target.value
    const updatedClients = {};
    const updatedUnits = {};
    if (userSelectedID) {
        const selectedUser = (userData || []).find((item) => item.auth_id == userSelectedID);
        if (!selectedUser) {
          setSelectedClients({});
          setSelectedUnits({});
          return;
        }
        const assigned = typeof selectedUser.client_and_unit === 'string' ? JSON.parse(selectedUser.client_and_unit || "[]") : selectedUser.client_and_unit;
        console.log(assigned);
        setAsignedData(assigned);
        
 
        if (Array.isArray(assigned)) {
 
            assigned.forEach((entry) => {
              const client = (clientAndUnit || []).find(c => c.client_id === entry.client_id);
 
              if (client) {
                updatedClients[entry.client_id] = true;
 
                (entry.unit_id || []).forEach((unit) => {
                  if ((client.unit_id || []).includes(unit)) {
                    updatedUnits[unit] = true;
                  }
                });
              }
            });
 
          } else {
          }
    }else{
        (clientAndUnit || []).forEach(client => {
            updatedClients[client.client_id] = false;
              (client.unit_id || []).forEach(unit => {
                updatedUnits[unit] = false;
              });
          });
    }
      setSelectedClients(updatedClients);
      setSelectedUnits(updatedUnits);
      
    let allClientUnits = [];
    rows.forEach(client => {
      // if (selectedClients[client.clientId]) {
        const units = Array.isArray(client.unitId)
          ? client.unitId
          : [client.unitId];
        allClientUnits = allClientUnits.concat(units);
      // }
    });
    const areAllChecked =
      allClientUnits.length > 0 &&
      allClientUnits.every(unit => updatedUnits[unit]);
    setIsAllUnitsChecked(areAllChecked);
  };
 
  // const handleUnitCheck = (unitId, isChecked) => {
  //   const updatedUnits = { ...selectedUnits, [unitId]: isChecked };

  //   let allClientUnits = [];
  //   clientAndUnit.forEach(client => {
  //     if (selectedClients[client.client_id]) {
  //       const units = Array.isArray(client.unit_id) ? client.unit_id : [client.unit_id];
  //       allClientUnits = allClientUnits.concat(units);
  //     }
  //   });

  //   setSelectedUnits(updatedUnits);
  // };
  const handleUnitCheck = (unitId, isChecked) => {
    const updatedUnits = {
      ...selectedUnits,
      [unitId]: isChecked
    };
  
    setSelectedUnits(updatedUnits);
  
    // get all units under selected clients
    let allClientUnits = [];
    rows.forEach(client => {
      // if (selectedClients[client.clientId]) {
        const units = Array.isArray(client.unitId)
          ? client.unitId
          : [client.unitId];
        allClientUnits = allClientUnits.concat(units);
      // }
    });
    const areAllChecked =
      allClientUnits.length > 0 &&
      allClientUnits.every(unit => updatedUnits[unit]);
    setIsAllUnitsChecked(areAllChecked);
  };
  
  const handleSelectAllUnits = (isChecked) => {
    let updatedUnits = { ...selectedUnits };
  
    rows.forEach(client => {
      // if (selectedClients[client.clientId]) {
        const units = Array.isArray(client.unitId)
          ? client.unitId
          : [client.unitId];
  
        units.forEach(unitId => {
          updatedUnits[unitId] = isChecked;
        });
      // }
    });
  
    setSelectedUnits(updatedUnits);
    setIsAllUnitsChecked(isChecked);
  };
  const handleClientCheck = (clientId, isChecked) => {
    let updatedUnits = { ...selectedUnits };
    const client = (clientAndUnit || []).find(c => c.client_name === clientId);
    if (client) {
      const units = Array.isArray(client.unit_id) ? client.unit_id : [client.unit_id];

      if (!isChecked) {
        units.forEach(unitId => {
          updatedUnits[unitId] = false;
        });
      } else {
        units.forEach(unitId => {
          updatedUnits[unitId] = true;
        });
      }
    }
    setSelectedUnits(updatedUnits);
    let allClientUnits = [];
    rows.forEach(client => {
      if (selectedClients[client.clientId]) {
        const units = Array.isArray(client.unitId)
          ? client.unitId
          : [client.unitId];
        allClientUnits = allClientUnits.concat(units);
      }
    });
    const areAllChecked =
      allClientUnits.length > 0 &&
      allClientUnits.every(unit => updatedUnits[unit]);
    setIsAllUnitsChecked(areAllChecked);
  };

  const rows = clientAndUnit?.filter((item) =>
    selectedClientID ? item.client_id === selectedClientID : true
    )
    .flatMap((item) =>
    item.unit_id.map((unit, unitIndex) => ({
      organisation: item.client_name,
      branch: item.unit_names[unitIndex],
      unitId: unit,
      clientId: item.client_id,
    }))
  );

  const filteredData = rows
    ? rows.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    ): [];
  

const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
const sortedData = [...filteredData]?.sort((a, b) => {
  if (!sortConfig.key) return 0;
  const aVal = a[sortConfig.key];
  const bVal = b[sortConfig.key];
  if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
  if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
  return 0;
});

  // sort funtion starts
  const handleSort = (key) => {
    setSortConfig((prev) => ({
        key,
        direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
};

const getSortIcon = (key) => {
  if (sortConfig.key !== key) return "";
  return sortConfig.direction === "asc" ? arrow_up : arrow_down;
};
const [currentPage, setCurrentPage] = useState(1);
const [recordsPerPage, setRecordsPerPage] = useState(10);
const indexOfLastRecord = currentPage * recordsPerPage;
const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
const currentRecords = sortedData.slice(indexOfFirstRecord, indexOfLastRecord);
const totalPages = Math.ceil(sortedData.length / recordsPerPage);
const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
        setCurrentPage(pageNumber);
    }
};
const getPageSizeOptions = (totalEntries) => {
  const options = [ 10, 20, 50, 100,200,300,400,500,600,];
  const filtered = options.filter(size => size < totalEntries);

  return [...filtered, totalEntries];
};


 const closeModel = () =>{
  setShowPermitted(false)
 }
 
const selectedEntries = clientAndUnit?.map((client) => {
  const branches = client.unit_id
    .map((unit, idx) =>
      selectedUnits[unit]
        ? { id: unit, name: client.unit_names[idx] }
        : null
    )
    .filter(Boolean);

  return {
    organisation: client.client_name,
    clientId: client.client_id,
    branches,
  };
}).filter((c) => c.branches.length > 0);
  return (
    <div className="contaner-fluid m-0">
      <div className="col-md-12 assign-permission-main-container">
        <div className="row ">
          <div className="col-md-12">
            <div className="mainTitle d-flex justify-content-between">
              <h5  className={`${activeTab == "Registers" ? "text-dark" : "text-white"}`}>Assign Organization To User</h5>
              <div className="selectUserData d-flex">
                <label htmlFor="" className={`${activeTab == "Registers" ? "text-dark" : "text-white"}`} >User Mail : </label>
                  <select name="" id=""
                    onChange={handleSelectChange}
                    value={selectedUserId}
                    >
                    <option value="">--select--</option>
                    {userData
                      ?.filter(item => checkRoles.includes(item.role_name))
                      .map(item => (
                        <option key={item.auth_id} value={item.auth_id}>
                          {item.user_email}
                        </option>
                      ))}
                  </select>
              </div>

            </div>
          </div>
        </div>
        <div className="row assign-permission-table-container">
        <div className="assignPermission-sub-header d-flex justify-content-between">
          <div className="title-header d-flex">
            <div className="logoicon">
              <img src={mainLogo} alt="" />
            </div>
            <h5>Assign Clients</h5>
          </div>
          <div className="FormsTable-search-box position-relative">
            <input
              type="text"
              className=""
              placeholder="Search here..."
              style={{
                backgroundColor: "#f9fafb",
                border: "none",
                width: "250px"
              }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <i
            className="bi bi-search position-absolute"
            style={{
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              color: "#9ca3af"
            }}
            ></i>
          </div>
          <div className="float-end d-flex assignPermission-sub-header-data ">
            <button className='btn btn-sm btn-primatry'>Total Branches : {rows?.length} </button>
            <button className='btn btn-sm btn-primadry' onClick={() => setShowPermitted(true)}><img src={permitted_branch} alt="" />Permitted Branches</button>
            <select name="" id=""
              onChange={(e) => setSelectedClientID(e.target.value)}
            >
              <option value="">All Orgs</option>
              {
                clientAndUnit?.map((data)=>(
                  <option value={data.client_id}>{data.client_name}</option>
                ))
              }
            </select>
          </div>
        </div>

        <div className="table-responsive assign-permission-table-height p-0 m-0">
          <table className='table'>
            <thead className=''>
              <tr>
                <th className='slno'>
                  <img src={slno_icon} alt="noImg" className='headerIcon' />
                  SL No.
                </th>
                <th
                    key={"Organisation Name"}
                    onClick={() => handleSort("organisation")}
                    style={{ cursor: "pointer" }}
                    className=""
                >
                  <img src={org_name_icon} alt="noImg" className='headerIcon' /> Organisation Name  {getSortIcon("organisation") &&<img src={getSortIcon("organisation")} alt="" className='arrow_img'/>}
                </th>
                <th
                    key={"Branch"}
                    onClick={() => handleSort("branch")}
                    style={{ cursor: "pointer" }}
                    className=""
                >
                  <img src={branch_icon} alt="noImg" className='headerIcon' /> Branch   {getSortIcon("branch") &&<img src={getSortIcon("branch")} alt="" className='arrow_img'/>}
                </th>
                <th
                    key={"Assign Permission"}
                    // onClick={() => handleSort("Assign Permission")}
                    // style={{ cursor: "pointer" }}
                    className=""
                >
                  {/* <img src={selected_icon} alt="noImg" className='headerIcon' /> */}
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={isAllUnitsChecked}
                    onChange={(e) => handleSelectAllUnits(e.target.checked)}
                  />
                   Select All Branches
                </th>
              </tr>
            </thead>
            <tbody>
              {currentRecords?.map((row, index) => (
                <tr key={`${row.clientId}-${row.unitId}`}>
                  
                  <td>{index + 1}</td>

                  <td>{row.organisation}</td>

                  <td>
                    <div className="d-flex align-items-center gap-2 reuseableEditable-avatar-circle-main-access">
                      {(() => {
                        const letter = row.branch?.charAt(0)?.toUpperCase() || "N";
                        return (
                          <>
                            <div
                              className="reuseableEditable-avatar-circle-access "
                            >
                              {letter}
                            </div>
                            <span>{row.branch}</span>
                          </>
                        );
                      })()}
                    </div>
                  </td>


                  {/* Assigned Permission */}
                  <td className=''>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={selectedUnits[row.unitId] || false}
                      onChange={(e) =>
                        handleUnitCheck(row.unitId, e.target.checked)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="row paginationdata">
          <div className="col-md-12 ">
          <div className="pagination align-items-center justify-content-between mt-3 row d-flex">
            {/* <div>
              <button type="submit" className="btn btn-success mt-3" onClick={selectedClienthandleSubmit}>
                Submit
              </button>
            </div> */}
            <div className=''>
              <div className=" text-center">
                
                {/* Prev button */}
                <button
                  className="page-btn-arrow"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </button>

                {(() => {
                  const pages = [];

                  if (totalPages <= 10) {
                    // Show all pages if small count
                    for (let i = 1; i <= totalPages; i++) {
                      pages.push(i);
                    }
                  } else {
                    pages.push(1); // Always show first

                    // Left ellipsis
                    if (currentPage > 4) {
                      pages.push("...");
                    }

                    // Sliding window around current page
                    const start = Math.max(2, currentPage - 2);
                    const end = Math.min(totalPages - 1, currentPage + 2);

                    for (let i = start; i <= end; i++) {
                      pages.push(i);
                    }

                    // Right ellipsis
                    if (currentPage < totalPages - 3) {
                      pages.push("...");
                    }

                    pages.push(totalPages); // Always show last
                  }

                  return pages.map((p, idx) =>
                    p === "..." ? (
                      <span key={`ellipsis-${idx}`} className="ellipsis">
                        ...
                      </span>
                    ) : (
                      <button
                        key={p}
                        className={`page-btn ${currentPage === p ? "active" : ""}`}
                        onClick={() => handlePageChange(p)}
                      >
                        {p}
                      </button>
                    )
                  );
                })()}

                {/* Next button */}
                <button
                  className="page-btn-arrow"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &gt;
                </button>
              </div>

            </div>

            <div className="">
            <div className="row float-end">
            <div className="d-flex align-items-center showPerPage">
              <span className="me-2">Show per page:</span>
              <select
                value={recordsPerPage}
                onChange={(e) => {
                  setRecordsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                {getPageSizeOptions(sortedData.length).map((size, i) => (
                  <option key={i} value={size}>
                    {size === sortedData.length ? "All" : size}
                  </option>
                ))}
              </select>
            </div>
            </div>
            </div>
          </div>
          </div>
          <div className='assignedSubmitBtnContainer'>
            <button type="submit" className="btn btn-primary mt-3 assignedSubmitBtn" onClick={() => setShowPermitted(true)}>
                Next
              </button>
          </div>
          
        </div>
        </div>
      </div>
      {showPermitted && (
        
    <Modal 
    show={showPermitted} 
    onHide={closeModel} 
    centered 
    dialogClassName="custom-modal-dialog-container"
    backdrop="static"
    keyboard={false}
    style={{ zIndex: "9999" }}
    className='bg-transparent d-flex justify-content-center'
  >
  {/* <button type="button" className=" float-end bg-light  " onClick={closeModel} aria-label="Close"><img src={into_icon} alt="" /></button> */}
  {showPermitted && (

<div className="assignClientCardMainContainer">

  <div className="assignClientCardContainer">
    <div className=" row">
    <div className="col-md-12 cancelImg">
    <button type="button" className=" float-end bg-light  " onClick={closeModel} aria-label="Close"><img src={into_icon} alt="" /></button>
    </div>
    </div>

    <div className="assignClientCardcontainerdata col-md-12">
      <div className="row">
        <div className=" d-flex justify-content-between assignClientCardheader">
          <h5>Selected Entries</h5>

          <span className="assignClientCardTotalSelected">

            Total Selected Entries:{" "}

            {selectedEntries.reduce((sum, org) => sum + org.branches.length, 0)}

          </span>
        </div>
      </div>

    </div>
    <div className="col-md-12 assignClientCarddataContainer">
      <div className="dataCard">
      {selectedEntries.map((org) => (

        <div key={org.clientId} className=" datas">

          <p className='clientName d-flex justify-content-between'>

            <span><strong>Organisation Name:</strong> {org.organisation}</span>

          <button

            className="btn btn-sm btn-link text-danger ms-1 p-0"

            onClick={() => handleClientCheck(org.organisation, false)}

          >

          <img src={mainInto} alt="" />

          </button>

          </p>

          <p className='unitNames'>

            <strong>Branch:</strong>{" "} <br />

            {org.branches.map((branch) => (

              <span

                key={branch.id}

                className="badge bg-light text-dark me-2 mb-2 d-inline-flex align-items-center"

              >

                {branch.name}

                <button

                  className="btn btn-sm btn-link text-danger ms-1 p-0"

                  onClick={() => handleUnitCheck(branch.id, false)}

                >

                <img src={mainInto} alt="" />

                </button>

              </span>

            ))}

          </p>

        </div>

      ))}
      </div>
    </div>
    {/* <div > */}
      <button className='btn btn-primary w-100'  onClick={selectedClienthandleSubmit}>Submit</button>
    {/* </div> */}

  </div>




</div>

)}
    
  </Modal>
  
      )}

      <Dialog
          open={openalert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to remove all selected clients? This action cannot be undone.

              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handleClosealert}>No</Button>
              <Button onClick={confirmUnassign}>Yes</Button>
          </DialogActions>
      </Dialog>
    </div>
  )
}

export default AssignClient
